import { render, staticRenderFns } from "./FormThankYouForm.vue?vue&type=template&id=707b41d1"
import script from "./FormThankYouForm.vue?vue&type=script&lang=js"
export * from "./FormThankYouForm.vue?vue&type=script&lang=js"
import style0 from "./FormThankYouForm.vue?vue&type=style&index=0&id=707b41d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports